import React from 'react'
import Highlight from './highlight'
import SlideInTop from '../utility/slideInTopAnimation'

const HighlightsSeries = props => (
  <div className="section">
      <SlideInTop>
        <h3 className="pb-12 text-2xl font-semibold">
          {props.title}
        </h3>
      </SlideInTop>
      <Highlight
        main={props.mainOne}
        description={props.descriptionOne}
      />
      <Highlight
        main={props.mainTwo}
        description={props.descriptionTwo}
      />
      <Highlight
        main={props.mainThree}
        description={props.descriptionThree}
      />
      {props.mainFour && (
        <Highlight
          main={props.mainFour}
          description={props.descriptionFour}
        />
      )}
      {props.mainFive && (
        <Highlight
          main={props.mainFive}
          description={props.descriptionFive}
        />
      )}
      {props.mainSix && (
        <Highlight
          main={props.mainSix}
          description={props.descriptionSix}
        />
      )}
  </div>
)

export default HighlightsSeries
